(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-cv-film]').forEach((film) => {
      if (film.dataset.initialized) return;
      film.dataset.initialized = 'true';
      const video = film.querySelector('video');
      let inView = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const canAutoplay = () => !reducedMotion.matches && !navigator.connection?.saveData;
      const sync = () => {
        if (!inView || document.hidden || !canAutoplay()) {
          video.pause();
          return;
        }
        // If the device blocks autoplay, keep the informative poster visible.
        const attempt = video.play();
        if (attempt) attempt.catch(() => {});
      };
      video.loop = true;
      reducedMotion.addEventListener?.('change', sync);
      document.addEventListener('visibilitychange', sync);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            inView = entry.isIntersecting && entry.intersectionRatio >= 0.3;
            sync();
          }
        }, { threshold: [0, 0.3] });
        observer.observe(video);
      }
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
